import React from 'react';
import { ShieldCheck, Lock, Clock, FileText } from 'lucide-react';

const iconMap = {
  'shield-check': ShieldCheck,
  'lock': Lock,
  'clock': Clock,
  'file-text': FileText,
};

const trustSignalsData = [
  {
    title: "No Win, No Fee",
    description: "25% + VAT only on success",
    icon: "shield-check"
  },
  {
    title: "Secure & GDPR Compliant",
    description: "Encrypted and protected",
    icon: "lock"
  },
  {
    title: "Fast Check in 2 Minutes",
    description: "Instant eligibility results",
    icon: "clock"
  },
  {
    title: "We Handle Paperwork",
    description: "Completely hassle-free",
    icon: "file-text"
  }
];

const TrustSignals = () => {
  return (
    <section className="bg-white border-y border-gray-100" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {trustSignalsData.map((signal, index) => {
            const Icon = iconMap[signal.icon];
            return (
              <div 
                key={index}
                className="flex flex-col items-center text-center space-y-3 group"
              >
                <div className="flex items-center justify-center w-14 h-14 bg-blue-100 rounded-2xl group-hover:bg-blue-600 transition-colors duration-300">
                  <Icon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-base font-semibold text-gray-900 whitespace-nowrap">
                  {signal.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed whitespace-nowrap">
                  {signal.description}
                </p>
              </div>
            );
          })}
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-sm text-gray-500 italic">
            Fees apply only after successful compensation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
